$(function () {
  $.fn.throttle = function (callback, options) {
    options = $.extend({
      interval: 256
    }, options);
    var time = Date.now();
    var lag;
    var debounceTimer;
    var debounceDelay = 16;

    return function () {
      lag = time + options.interval - Date.now();
      if (lag < 0) {
        // console.log( time + "：throttle：" + lag);
        callback();
        time = Date.now();
      } else {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          // console.log( time + "：debounce：" + (options.interval - lag + debounceDelay));
          callback();
        }, (options.interval - lag + debounceDelay));
      }
    };
  };

  var $animationElm = $('.scEventReady');
  var myCallback = function () {
    var wh = $(window).height();
    var sc = $(window).scrollTop();
    if (sc > 100) {
      $('body').addClass('sc');
    } else {
      $('body').removeClass('sc');
    }
    $animationElm.each(function () {
      if (wh + sc - 200 >= $(this).offset().top) {
        $(this).addClass('scEventStart');
      }
    });
  };

  $(window).on('scroll resize', $.fn.throttle(myCallback));

  // $(window).on('scroll', $.fn.throttle(myCallback,{
  //  interval: 64  //オプション
  // }));
});
